import type { SettingsSource } from '../models/settings-hub.model';

import { field } from './settings-builders';

/**
 * The switches that open the new version of a module instead of the legacy one: `ConfigurationManagerService.isModuleAngular`
 * reads the preference `migration.<module>` to decide.
 */
export const INTERFACE_SUBCATEGORY: SettingsSource = {
    id: 'interface',
    cards: [
        {
            id: 'interface-update',
            settings: [
                field.toggle('migration.bookings', 'SETTINGS.SETTINGS.MIGRATION_BOOKINGS'),
                field.toggle('migration.items', 'SETTINGS.SETTINGS.MIGRATION_ITEMS'),
                field.toggle('migration.history.e_invoices', 'SETTINGS.SETTINGS.MIGRATION_HISTORY_E_INVOICES'),
                field.toggle('migration.fidelity', 'SETTINGS.SETTINGS.MIGRATION_FIDELITY'),
                field.toggle('migration.settings.printers', 'SETTINGS.SETTINGS.MIGRATION_SETTINGS_PRINTER'),
                field.toggle('migration.stock.management', 'SETTINGS.SETTINGS.MIGRATION_STOCK_MANAGEMENT'),
                field.toggle('migration.stock.movements', 'SETTINGS.SETTINGS.MIGRATION_STOCK_MOVEMENTS'),
                field.toggle('migration.settings.general', 'SETTINGS.SETTINGS.MIGRATION_SETTINGS_GENERAL'),
                field.toggle('migration.cashregister.ui', 'SETTINGS.SETTINGS.MIGRATION_CASHREGISTER_UI')
            ]
        }
    ]
};
